import { styled, Paper } from "@mui/material";
import { errorResponse } from "./Constants";
import { logEvent } from "../Services/chat-bot-service";

export const getErrorMessage = (err: any) => {
    let errorRes: { status: number, message: string } = errorResponse;
    if (err.response! && err.response!.data!) {
        errorRes = {
            status: err.response!.data!.errorCode!,
            message: err.response!.data!.errorMessage!
        }
    }
    return errorRes;
}


export const menuProps = (dropdownWidth: number) => {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: dropdownWidth,
            },
        },
    };
    return MenuProps;
}

export const getFileSizeInMB = (file: File) => {
    return Math.ceil(file.size / Math.pow(1024, 2));
}

export const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));


const patterns = {
    green: [
        /\+\d+\.\d+pts/g, // Match +2.5pts
        /-\d+\.\d+pts/g, // Match -2.5pts
        /\+\d+\.\d+%/g,    // Match +2.5%

        /\+\d+pts/g, // Match +2pts
        /-\d+pts/g, // Match -2pts
        /\+\d+%/g,    // Match +2%
    ],
    red: [
        /-\d+\.\d+pts/g,     // Match -2.5pts
        /\(-\d+\.\d+pts\)/g, // Match (-2.5pts)
        /-\d+\.\d+%/g,        // Match -2.5%

        /-\d+pts/g,     // Match -2pts
        /\(-\d+pts\)/g, // Match (-2pts)
        /-\d+%/g        // Match -2%
    ],
    bold: [
        /-(.*?):/g
    ]
};
export const highlightPatterns = (inputString: string) => {
    // Apply highlighting for green patterns
    patterns.green.forEach(pattern => {
        inputString = inputString.replace(pattern, (match: any) => `<span style="color: green">${match}</span>`);
    });

    // Apply highlighting for red patterns
    patterns.red.forEach(pattern => {
        inputString = inputString.replace(pattern, (match: any) => `<span style="color: red">${match}</span>`);
    });

    inputString = inputString.replace(/^- /gm, '• ');
    return inputString.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
}

export const callLogEvent = async (event_name: string, event_description: string) => {
    const currentUserEmail = sessionStorage.getItem("emailid")?.toLowerCase();
    await logEvent({
        name: event_name,
        description: event_description,
        created_by: currentUserEmail
    });
}

export const getSeconds = (startTime: any, endTime: any) => {
    const seconds = ((endTime - startTime) / 1000).toFixed(2);
    return seconds;
}

export const getRandomOfFive = () => {
    const a = [1, 2, 3, 4, 5];
    let i = Math.floor(Math.random() * a.length);
    return a[i];
}
